import gql from 'graphql-tag';

// query the seller promotions belonging to the user
const GET_SELLER_PROMOTIONS = gql`
  query getSellerPromotions {
    viewer {
      sellerPromotions {
        id
        createdAt
        createdBy
        approvedAt
        approvedBy
        deletedAt
        deletedBy
        details {
          activatesAt
          expiresAt
          name
          code
          minPrice
          value {
            type
            value
          }
        }
        eligibilityRequirements {
          verticals
          tiers
          countryIso2Codes
          products {
            fileName
            uploadIsComplete
            uploadFailed
          }
          skus {
            fileName
            uploadIsComplete
            uploadFailed
          }
          customerAudiences
          customers {
            fileName
            uploadIsComplete
            uploadFailed
          }
          customersDenyList {
            fileName
            uploadIsComplete
            uploadFailed
          }
          customersAllowList {
            fileName
            uploadIsComplete
            uploadFailed
          }
        }
      }
    }
  }
`;

export default GET_SELLER_PROMOTIONS;
